// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./Loading.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export class Loading extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.loading },
            React.createElement("div", { className: styles.centering },
                React.createElement("div", { className: styles.text }, "Loading your"),
                React.createElement("div", { className: styles.logo }),
                React.createElement("div", { className: styles.cssLoader },
                    React.createElement("ul", null,
                        React.createElement("li", null),
                        React.createElement("li", null),
                        React.createElement("li", null),
                        React.createElement("li", null))))));
    }
}
